var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickActionDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60396 11.8561L4.16419 8.83885C3.94527 8.64692 3.94527 8.33573 4.16419 8.14389C4.38292 7.95204 4.73768 7.95204 4.95639 8.14389L8.00006 10.8137L11.0436 8.14397C11.2624 7.95211 11.6172 7.95211 11.8359 8.14397C12.0547 8.33582 12.0547 8.64699 11.8359 8.83893L8.39607 11.8562C8.28665 11.9521 8.1434 12 8.00008 12C7.85668 12 7.71332 11.952 7.60396 11.8561Z",
    fill: "#027BFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60396 7.85609L4.16419 4.83885C3.94527 4.64692 3.94527 4.33573 4.16419 4.14389C4.38292 3.95204 4.73768 3.95204 4.95639 4.14389L8.00006 6.81368L11.0436 4.14397C11.2624 3.95211 11.6172 3.95211 11.8359 4.14397C12.0547 4.33582 12.0547 4.64699 11.8359 4.83893L8.39607 7.85616C8.28665 7.95209 8.1434 8 8.00008 8C7.85668 8 7.71332 7.952 7.60396 7.85609Z",
    fill: "#027BFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionDropdown);
export default __webpack_public_path__ + "static/media/quick_action_dropdown.1484f7a0caf3b25971e7a790d59ad1dc.svg";
export { ForwardRef as ReactComponent };